<div
  [ngStyle]="contentStyle"
  [ngClass]="baseCssConfig?.borderClass !== 'none' ? baseCssConfig?.borderClass : ''"
>
  @if (viewType === viewTypes.TABLE) {
    <finxone-web-frontend-desktop-listing
      [entityData]="displayData"
      [dataIn]="widgetConfig"
      [pageNumber]="pageNumber"
      [isApiInProgress]="showFetchingState"
      [fetchingContent]="renderedFetchingTemplate"
      [emptyTableMsg]="renderedNoRecordsTemplate"
      [uniqueId]="'id'"
      [menuPopupCss]="menuPopupCss"
      [menuItemsStatus]="menuItemsStatus"
      [totalListCount]="totalListCount"
      [enableClickableRow]="enableClickableRow"
      (pageChange)="onPageChange($event)"
      (rowData)="onTableItemClick($event)"
      (performAction)="performAction($event)"
      (actionEvent)="handleAction($event)"
      [actionOptions]="actionOptions"
    ></finxone-web-frontend-desktop-listing>
  } @else {
    <div class="w-100" [id]="listContainerId" [ngStyle]="{ maxHeight: containerHeight, overflowY: 'auto' }">
      @if (showFetchingState) {
        <div class="w-100" [innerHTML]="renderedFetchingTemplate | safeHtml"></div>
      } @else if (!displayData.length) {
        <div [innerHTML]="renderedNoRecordsTemplate | safeHtml"></div>
      } @else {
        @for (recurringPayment of displayData; track recurringPayment.id) {
          <finxone-web-frontend-list-item
            [textContentStyle]="textContentStyle"
            [customClass]="isGlobalStylingEnabled ? 'global-list-styling' : ''"
            [content]="widgetProperties?.['textContent'] || ''"
            [customHandlebarModel]="recurringPaymentHandleBarModel(recurringPayment, $index)"
            (click)="onListItemClick($event, recurringPayment)"
            [gestures]="widgetProperties?.gestures"
            [listActions]="listActions"
            (actionTriggered)="onListActionTriggered($event, recurringPayment)"
          ></finxone-web-frontend-list-item>
        }
      }
    </div>
  }
</div>
